import React from 'react';
import PropTypes from 'prop-types';

const SendIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14">
        <path d="M13.745.255a.877.877 0 00-.915-.207L6.864 2.167.584 4.396a.876.876 0 00-.02 1.643l4.685 1.8a1.584 1.584 0 01.908.9l1.8 4.678a.866.866 0 00.817.578.87.87 0 00.817-.582l4.35-12.224a.875.875 0 00-.196-.934zm-8.118 6.6L1.39 5.24l10.293-3.665-5.548 5.543a2.891 2.891 0 00-.508-.263zm3.128 5.739L7.138 8.365a2.539 2.539 0 00-.26-.5l5.548-5.547z" fill={fill} />
    </svg>
);

SendIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

SendIcon.defaultProps = {
    width: '14',
    height: '14',
    fill: '#fff'
};

export default SendIcon;
